import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  connect() {
    const toastBootstrap = Toast.getOrCreateInstance(this.element)
    toastBootstrap.show()
  }
}
